<template>
  <div class="slice">
    <div class="wapper">
      <div class="leftBox">
        <el-card class="box-card" style="height:100%">
          <el-page-header @back="goBack" content="阅片" style="margin:15px 0;"></el-page-header>
          <slice :casesId="casesId" @on-submit="onSubmit" ref="slice" />
        </el-card>
      </div>
      <div class="rightBox">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span class="title">患者资料</span>
          </div>
          <div class="p_bd">
            <div class="box">
              <div class="column">
                <span class="item">
                  <span class="title">就诊号:</span>
                  <span class="txt">{{userInfo.case_number}}</span>
                </span>
                <span class="item">
                  <span class="title">住院号:</span>
                  <span class="txt">{{userInfo.hospital_num}}</span>
                </span>
              </div>
              <div class="column">
                <span class="item">
                  <span class="title">检查日期:</span>
                  <span class="txt">{{userInfo.date}}</span>
                </span>
                <span class="item">
                  <span class="title">籍贯:</span>
                  <span class="txt">{{userInfo.native_place}}</span>
                </span>
              </div>
              <div class="column">
                <span class="item">
                  <span class="title">姓名:</span>
                  <span class="txt">{{userInfo.name}}</span>
                </span>
                <span class="item">
                  <span class="title">出生日期:</span>
                  <span class="txt">{{userInfo.birthdate}}</span>
                </span>
              </div>
              <div class="column">
                <span class="item">
                  <span class="title">联系电话:</span>
                  <span class="txt">{{userInfo.moblie}}</span>
                </span>
                <span class="item">
                  <span class="title">胎数:</span>
                  <span class="txt" v-text="getLitter(userInfo.litter_index)"></span>
                </span>
              </div>
              <div class="column">
                <span class="item">
                  <span class="title">出生体重:</span>
                  <span class="txt">{{userInfo.barth_weight}}</span>
                </span>
                <span class="item">
                  <span class="title">生产方式:</span>
                  <span class="txt" v-text="getPregnancy(userInfo.pregnancy)"></span>
                </span>
              </div>
              <div class="column">
                <span class="item">
                  <span class="title">出生胎龄:</span>
                  <span class="txt">{{userInfo.ga}}</span>
                </span>
                <span class="item">
                  <span class="title">吸氧史:</span>
                  <span class="txt" v-text="getOxygen(userInfo.oxygen)"></span>
                </span>
              </div>
              <div class="column">
                <span class="item">
                  <span class="title">矫正胎龄:</span>
                  <span class="txt">{{userInfo.correct_ga}}</span>
                </span>
                <span class="item">
                  <span class="title">出生医院:</span>
                  <span class="txt">{{userInfo.birth_hospital_name}}</span>
                </span>
              </div>
              <!-- <div class="column">
                <span class="item">
                  <span class="title">家族病史:</span>
                  <span class="txt">{{userInfo.correct_ga}}</span>
                </span>
                <span class="item">
                  <span class="title">初步描述:</span>
                  <span class="txt">{{userInfo.describe}}</span>
                </span>
              </div>-->
            </div>
          </div>
        </el-card>
        <el-card class="box-card pad">
          <div slot="header" class="clearfix">
            <span class="title">家族病史:</span>
          </div>
          <el-input type="textarea" :disabled="true" :rows="2" v-model="userInfo.correct_ga"></el-input>
        </el-card>
        <el-card class="box-card pad">
          <div slot="header" class="clearfix">
            <span class="title">初步描述:</span>
          </div>
          <el-input type="textarea" :disabled="true" :rows="2" v-model="userInfo.describe"></el-input>
        </el-card>
        <el-card class="box-card pad">
          <div slot="header" class="clearfix">
            <span class="title">眼底描述</span>
          </div>
          <el-input type="textarea" :rows="2" v-model="userInfo.eye_describe" placeholder="请输入眼底描述"></el-input>
          <!-- <div class="p_bd">{{userInfo.eye_describe}}</div> -->
        </el-card>
        <el-card class="box-card pad">
          <div slot="header" class="clearfix">
            <span class="title">医嘱</span>
          </div>
          <div class="p_bd">
            <el-input placeholder="请输入医嘱内容" v-model="drugs.remark"></el-input>
            <el-input type="textarea" :rows="2" v-model="drugs.dosage" placeholder="请输入用药说明"></el-input>
            <el-date-picker
              style="width:100%;"
              v-model="drugs.time"
              type="datetime"
              placeholder="请输入复诊时间"
            ></el-date-picker>
            <el-input type="textarea" :rows="2" placeholder="备注" v-model="drugs.notes"></el-input>
          </div>
        </el-card>
        <el-card class="box-card pad">
          <div slot="header" class="clearfix">
            <span class="title">诊断</span>
          </div>
          <div class="p_bd">
            <el-input placeholder="请输入诊断内容" v-model="drugs.diagnose"></el-input>
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入病历备注（选填）"
              v-model="drugs.cases_notes"
            ></el-input>
            <el-button
              type="success"
              style="background:rgb(0, 175, 255);border:rgb(0, 175, 255);"
              @click="addReport()"
            >创建报告</el-button>
          </div>
        </el-card>
      </div>
    </div>
    <Vfooter />
  </div>
</template>

<script>
import utils from "@/utils";

import slice from "@/components/readFilm/index";
import Vfooter from "@/components/footer/index";
import { readfilmList, patientsInfo, readfilmPicList, reportAdd } from "@/api";
export default {
  components: { slice, Vfooter },
  props: {},
  data() {
    return {
      pageList: {
        page: 1,
        total: 10,
        size: 10
      },
      userInfo: {},
      casesId: "",
      sickId: "",
      sickImId: "",
      orderId: "",
      drugs: {},
      errData: {}
    };
  },
  created() {},
  mounted() {
    this.casesId = this.$route.query.casesId;
    this.sickImId = this.$route.query.sickImId;
    this.sickId = this.$route.query.sickId;
    this.orderId = this.$route.query.orderId;
    this.initPatientsInfo();
  },
  activited() {},
  update() {},
  beforeRouteUpdate() {},
  methods: {
    goBack() {
      let from = this.$route.query.from,
      path;
      switch (from) {
        case "chat":
          path='/index/work/chart'
          break;
        case "workDetail":
          path='/index/work/workDetail'
          break;
        default:path = "/index/work/patients"
          break;
      }
      this.$router.push({
        path:path,
        query:{
          tabNum:this.$route.query.tabNum
        }
      });
    },
    //获取患者个人信息
    initPatientsInfo() {
      let data = {
        sick_im_accid: this.$route.query.sickImId
      };
      patientsInfo(data).then(res => {
        this.userInfo = res.data;
      });
    },
    //胎数处理
    getLitter(num) {
      switch (num) {
        case 2:
          return "双";
          break;
        case 3:
          return "三";
          break;
        case 4:
          return "四";
          break;

        default:
          return "单";
          break;
      }
    },
    //出生方式处理
    getPregnancy(num) {
      switch (num) {
        case 2:
          return "剖腹";
          break;
        default:
          return "顺产";
          break;
      }
    },
    getOxygen(num) {
      switch (num) {
        case 2:
          return "有";
          break;
        default:
          return "无";
          break;
      }
    },
    //病例提交
    onSubmit(errData) {
      this.errData = errData;
      this.drugs.result = errData.textData;
      this.$message({
        type: "success",
        message: "请继续提交医嘱和诊断后生成报告"
      });
    },
    /*
     * 提示信息
     * */
    elementTips: function(type, message) {
      const $t = "";
      this.$message({
        showClose: true,
        message: message,
        type: type
      });
    },
    //报告添加
    addReport() {
      console.log('dsafdsaf:',this.errData)
      if (!this.userInfo.eye_describe) {
        this.$message({
          type: "error",
          message: "请输入眼底描述"
        });
        return;
      } else if (!this.drugs.remark) {
        this.$message({
          type: "error",
          message: "请输入医嘱"
        });
        return;
      } else if (!this.drugs.dosage) {
        this.$message({
          type: "error",
          message: "请输入用药说明"
        });
        return;
      } else if (!this.drugs.time) {
        this.$message({
          type: "error",
          message: "请输入复诊时间"
        });
        return;
      } else if (!this.drugs.diagnose) {
        this.$message({
          type: "error",
          message: "请输入诊断内容"
        });
        return;
      } else if (this.errData.length <=0 || this.errData.textData.length<=0) {
        this.$confirm('当前阅片图片未添加标记或异常，是否提交')
          .then(_ => {
            this.submitData()
          })
          .catch(_ => {
            return;
          });
      }else{
        this.submitData()
      }
    },
    //
    submitData() {
      this.drugs.time = utils.formatDate(this.drugs.time);
      this.drugs.eye_describe = this.userInfo.eye_describe;
      let data = {
        read_film: this.errData.errList || JSON.stringify([]),
        drugs: this.drugs,
        cases_id: this.casesId,
        orders_id: this.orderId,
        sick_id: this.sickId
      };
      reportAdd(data).then(res => {
        if (res.code == 1) {
          this.elementTips("success",res.msg);
        } else {
          this.elementTips("error",res.msg);
        }
        this.reast();
      });
    },
    //重置输入框
    reast() {
      //TODO:
      this.userInfo.eye_describe = "";
      this.drugs.remark =　"";
      this.drugs.dosage =　"";
      this.drugs.time =　"";
      this.drugs.notes =　"";
      this.drugs.diagnose =　"";
      this.drugs.cases_notes =　"";
      this.$refs.slice.reast();
    }
  },
  filter: {},
  computed: {},
  watch: {}
};
</script>

<style lang="scss" scoped>
.wapper {
  padding: 20px;
  display: flex;
  flex-direction: row;
  .leftBox {
    flex: 0 0 60%;
  }
  .rightBox {
    flex: 0 0 38%;
    margin-left: 20px;
    .p_bd {
      line-height: 25px;
      color: #606266;
      .el-input {
        margin: 8px 0;
      }
      .el-button {
        margin-top: 8px;
      }
      .title {
        margin-right: 10px;
      }
      .box {
        .column {
          .item {
            width: 50%;
            display: inline-block;
          }
        }
      }
    }
  }
}
.pad {
  margin-top: 20px;
}
</style>
